module.exports = __webpack_public_path__ + "static/pro-niti-travel-db11c0e0b71feb0226a5f0a626392baf.png";